import { render, staticRenderFns } from "./TermsPage.vue?vue&type=template&id=7811355b&scoped=true&"
import script from "./TermsPage.vue?vue&type=script&lang=ts&"
export * from "./TermsPage.vue?vue&type=script&lang=ts&"
import style0 from "./TermsPage.vue?vue&type=style&index=0&id=7811355b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7811355b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VContainer,VIcon,VTab,VTabItem,VTabs,VTabsItems})
